







import BackLink from "@/components/app/BackLink.vue";
import { Component, Vue } from "vue-property-decorator";
import C2BVue from "fs-pb-vue2/vueModels/operations/sbp/C2BVue";

@Component({
  components: { BackLink },
})
export default class C2BOperation extends C2BVue {
  async mounted(): Promise<void> {
    await this.init();
  }
}
